import React, { useEffect, useState } from "react";
import "../style/global.css";
import Button from "../common/Button/Button";
import BrustGif from "../../src/assets/Images/congo.gif";
import UpArrow from "../../src/assets/Images/up.png";
import DownArrow from "../../src/assets/Images/down.png";
import { verifyOtpData, generateLead, fetchUserDetails } from "../api/action";
import ToastMsg from "../common/ToastMsg";
import mixpanel from "mixpanel-browser";
import { Loader } from '../common/Loader';
import { notifyVisitorEvent } from "../api/action";

const formatCurrency = (number) => {
  if (number === null || number === undefined) return "0";
  const [integerPart, decimalPart] = number.toString().split(".");
  const lastThreeDigits = integerPart.slice(-3);
  const otherDigits = integerPart.slice(0, -3);
  const formattedIntegerPart =
    otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
    (otherDigits ? "," : "") +
    lastThreeDigits;
  return `${formattedIntegerPart}${decimalPart ? `.${decimalPart}` : ""}`;
};



const SuccessScreen = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [portfolioValue, setPortfolioValue] = useState("")
  const [loader, setLoader] = useState(false);
  const [loaderNew, setLoaderNew] = useState(false);
  const [error, setError] = useState(null);
  const [portfolioData, setPortfolioData] = useState([]);
  const [loanValues, setLoanValues] = useState({});
  const [leadData, setLeadData] = useState({
    name: "",
    mobileNumber: "",
    email: "",
    panCard: "",
  });

  const toggleDropdown = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const otpVerified = urlParams.get("otpVerified");


    
    if (otpVerified !== "true") {
      window.location.href = "/";
    } else {
      handleVerifyOtp();
      handleFetchUserDetails();
    }
  }, []);

  const handleVerifyOtp = () => {
    setLoaderNew(true)
    verifyOtpData()
      .then((response) => {
// console.log(response, "reshere");


       
        setPortfolioData(response?.data?.securitiesDetails || []);
        setLoanValues({
          availableLoanValue: response?.data?.availableLoanValue || 0,
          totalPortfolioValue: response?.data?.totalPortfolioValue || 0,
          availablePortfolioValue: response?.data?.availablePortfolioValue || 0,
        });

        const portfolioValue = response?.data?.availablePortfolioValue;
        setPortfolioValue(portfolioValue)

        if (portfolioValue === 0) {
          
          setLoaderNew(false);
          window.location.href = "/loan-reject";
        }
        else if (portfolioValue >= 15000) {
          setLoaderNew(false);
          const UserID = localStorage.getItem("UserId")
         
        
          const payload = {
            event_name: "Viewed_Eligible_screen",
            event_body: {
                  "platform" : "m-site",
              },
          };
          if (response?.status=== 400){
            ToastMsg("We’re having trouble loading your portfolio. Please try again shortly.", "error");
          }
          notifyVisitorEvent(payload)
            .then((response) => {
              console.log("NotifyVisitor button_click Event Sent:", response);
            })
            .catch((error) => {
              console.error("Error sending NotifyVisitor button_click event:", error);
            });


          mixpanel.track("Viewed_Eligible_screen", {
            "Platform": "m-site",
          })
        }
        else {
          setLoaderNew(false)

          window.location.href = "/loan-reject?keyfrom=successpage";
        }
      })
      .catch((err) => {
        setLoaderNew(false);
        setError(err?.message);
        ToastMsg("We’re having trouble loading your portfolio. Please try again shortly.", "error");
      });
  };


  const handleFetchUserDetails = () => {
    setLoader(true);
    fetchUserDetails()
      .then((data) => {

        const userData = {
          name: data.response.name,
          mobileNumber: data.response.phone_number,
          email: data.response.email || "",
          panCard: data.response.pan || "",
        };

        setLeadData(userData);
      })
      .catch((err) => {
        setError(err?.message);
        ToastMsg(err?.message, "error");
      });
  };








  const handleGenerateLead = (leadData) => {
    const UserID = localStorage.getItem("UserId");
  
    const payload = {
      event_name: "Interacted_Eligible_screen",
      event_body: {
        "Clicked on": "Continue",
        "Platform": "m-site",
      },
    };
  
    notifyVisitorEvent(payload)
      .then((response) => {
        console.log("NotifyVisitor button_click Event Sent:", response);
        if (response?.status === 200) {
          handleGenerateLeadAPI(leadData);
        } else {
          ToastMsg("Failed to notify visitor event", "error");
        }
      })
      .catch((error) => {
        console.error("Error sending NotifyVisitor button_click event:", error);
        ToastMsg("Error notifying visitor event", "error");
      });
  };
  
  const handleGenerateLeadAPI = (leadData) => {
    setLoader(true);
    generateLead(leadData)
      .then((data) => {
        setLoader(false);
  
        const leadResponse = {
          leadId: data?.response?.leadId || "",
          status: data?.response?.status || "",
          message: data?.response?.message || "",
        };
  
        localStorage.setItem("leadDetails", JSON.stringify(leadResponse));
        localStorage.setItem("leadDetailsGenerated", "true");
        window.dispatchEvent(new Event("storageChanged"));
  
        ToastMsg("Lead generated successfully!", "success");
        console.log(data, "dtatattt");
  
        const redirectUrl = data?.response?.redirectUrl;
        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          ToastMsg("No redirect URL found!", "error");
        }
      })
      .catch((err) => {
        setLoader(false);
        setError(err?.message);
        ToastMsg(err?.message, "error");
      });
  };
  
 


  return (
    <div className="loan-success-container">
      {loaderNew && loader? <Loader /> :
       
        <div>
          <>
          <div className="top-section">
            <img className="gif-success" src={BrustGif} width={170} alt="Success" />
            <div className="congratulations">
              <h2>Congratulations!</h2>
              <p>Your available loan limit is</p>
              <h1> <span className="rupeesign">₹</span>{formatCurrency(loanValues.availableLoanValue)}</h1>
            </div>
          </div>

          <div className="portfolio-summary">
            <span className="portf">Portfolio</span>
            <div className="summary-grid box-shadow br-10 mt-16">
              <div>
                <span className="gray-text">Total Mutual Fund Portfolio</span>
                <span className="portfolio-text"><span className="rupeesymbol">₹</span>{formatCurrency(loanValues.totalPortfolioValue)}</span>
              </div>
              <div>
                <span className="gray-text">Available for Pledging</span>
                <span className="portfolio-text"><span className="rupeesymbol">₹</span>{formatCurrency(loanValues.availablePortfolioValue)}</span>
              </div>
              <div>
                <span className="gray-text">Available Loan Limit</span>
                <span className="portfolio-text"><span className="rupeesymbol">₹</span>{formatCurrency(loanValues.availableLoanValue)}</span>
              </div>
            </div>
          </div>

          <div className="portfolio-list mb-160">
            <h3>List of your Portfolio</h3>
            <div className="portfolio-container box-shadow br-10">
              <div className="portfolio-header-row">
                <span className="header-title">Name of Security</span>
                <span className="header-title isinpadding">ISIN</span>

              </div>
              {portfolioData.map((item, index) => (
                <div className="portfolio-item" key={index}>
                  <div className="portfolio-header" onClick={() => toggleDropdown(index)}>
                    <div className="portfolio-header-content">
                      <span className="security-name">{item.name}</span>
                      <span className="isin">{item.isin}</span>
                    </div>
                    <span className="dropdown-icon">
                      {expandedIndex === index ? (
                        <img src={UpArrow} width="12px" alt="Up Arrow" />
                      ) : (
                        <img src={DownArrow} width="12px" alt="Down Arrow" />
                      )}
                    </span>
                  </div>
                  {expandedIndex === index && (
                    <div className="portfolio-details">
                      <div className="details-row">
                        <span>Loan Amount</span>
                        <span>{formatCurrency(item.loanAmount)}</span>
                      </div>
                      <div className="details-row">
                        <span>Available Value</span>
                        <span>{formatCurrency(item.availableValue)}</span>
                      </div>
                      <div className="details-row">
                        <span>Total Units</span>
                        <span>{formatCurrency(item.availableQuantity)}</span>
                      </div>
                      <div className="details-row">
                        <span>NAV</span>
                        <span>{item.currentPrice}</span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          

          <Button
            sslSecure="false"
            btnshadow="true"
            onClick={() => handleGenerateLead(leadData)}
            btnName="Proceed to take Loan"
          />
          </>
          {/* } */}
        </div>
        

        }


    </div>
  );
};

export default SuccessScreen;
